<template>
  <section class="section small-padding">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <h2>
            <i class="fa fa-whatsapp"></i> Notificaciones Automáticas
          </h2>
        </div>
        <div class="col-md-6 text-right">
          <h2 class="clickeable" @click="showModalChangeToken()"><i class="fa fa-lock"></i></h2>
        </div>


      </div>
      <div class="box-header-lg row">
      <div class="row">
        <div class="col-md-4">
          <label>EMPRESA</label>
          <select
            class="form-control select2 filter-select2"
            ref="slEmpresa"
            multiple
            style="z-index:1000; width:100%!important; max-width:100%;"
            data-select2-container="big-text"
          >
            <option
              v-for="empresa in empresas"
              :key="empresa._id"
              :value="empresa._id"
            >{{empresa.empresa.razonSocial}} - {{empresa.denominacion}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>NOMBRE</label>
          <input type="text" class="form-control" v-model="filtros.nombre"/>
        </div>
        <div class="col-md-4">
          <label>USUARIO</label>
          <input type="text" class="form-control" v-model="filtros.usuario"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-md-offset-4">
          <label>TELEFONO</label>
          <input type="text" class="form-control" v-model="filtros.telefono"/>
        </div>
        <div class="col-md-4">
          <label>SUSCRIPTO</label>
          <br/>
          <div class="btn-group" role="group" aria-label="...">
            <button type="button" @click.prevent="filtroNotificable('true')" class="btn btn-outline btn-sm" v-bind:class="{ active: filtros.notify == 'true' }">Si</button>
            <button type="button" @click.prevent="filtroNotificable('all')" class="btn btn-outline btn-sm" v-bind:class="{ active: filtros.notify == 'all' }">Todos</button>
            <button type="button" @click.prevent="filtroNotificable('false')" class="btn btn-outline btn-sm" v-bind:class="{ active: filtros.notify == 'false' }">No</button>
          </div>          
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center" style="padding-top:22px;">
          <a class="btn btn-success btn-fill" @click.prevent="filtrarUsuarios()">Aplicar</a>
        </div>
      </div>

      </div>
      <div class="panel-group">
        <div class="row">
          <div class="col-md-12 text-center" v-if="loading">
            <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
          </div>
        </div>
        <div>
          <table class="table" v-if="!loading&&usuarios.length>0">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Empresa</th>
                <th>Telefono</th>
                <th>Usuario</th>
                <th>Email</th>
                <th>Notificar</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(camp,idx) in usuarios">
                <td>
                  <label>{{camp.displayName}}</label>
                </td>
                <td v-if="camp.sucursalAsociada">{{camp.sucursalAsociada.empresa.razonSocial}} - {{camp.sucursalAsociada.denominacion}}</td>
                <td v-else></td>
                <td v-if="!camp.editing&&!editingUser">{{camp.telefonoCelular}} <i class="text-brand fa fa-pencil clickeable" @click="edit(camp)"></i></td>
                <td v-if="camp.editing">
                  <div class="input-group">
                    <span class="input-group-addon" id="basic-addon1">+549</span>
                    <input type="number" autocomplete="off" :value="camp.telefonoCelular" v-model="editingUser.telefonoCelular" ref="telefonoCelular" name="telefonoCelular" id="telefonoCelular" class="form-control">                        
                    <span class="input-group-addon">
                      <i style="margin-right:4px;" @click.prevent="cancel()" class="fa fa-times text-danger clickeable"></i>
                      <i @click.prevent="save()" class="fa fa-save text-brand clickeable"></i>
                    </span>
                  </div>
                  <span class="label label-danger" v-if="errorCellphoneFormat">El número es incorrecto</span>
                  <span class="label label-danger" v-if="errorCellphoneUnique">El número ya está registrado por otro usuario</span>
                </td>
                <td>{{camp.username}}</td>
                <td>{{camp.email}}</td>
                <td>
                  <span v-if="camp.notificarWhatsapp&&camp.telefonoCelular">
                    <i @click="toggleNotifyUser(camp)"  class="fa clickeable fa-2x fa-whatsapp text-primary"></i>
                  </span>
                  <span v-if="!camp.notificarWhatsapp&&camp.telefonoCelular">
                    <i @click="toggleNotifyUser(camp)" class="fa fa-2x clickeable fa-times text-danger"></i>
                  </span>
                  <span v-if="!camp.telefonoCelular">
                    <i class="fa fa-2x fa-times text-default"></i>
                  </span>
                </td>
                <td style="position:relative;" v-if="camp.telefonoCelular&&camp.notificarWhatsapp">
                        <button class="btn btn-brand dropdown-toggle" data-toggle="dropdown" id="dd1" aria-expanded="true">
                          Notificar  <i class="fa fa-angle-down"></i>
                        </button>
                        <ul class="dropdown-menu super" aria-labelledby="dd1">
                          <li>
                            <a class="clickeable" @click="sendNotification(camp)">Enviar notificacion personalizada</a>
                          </li>
                          <li>
                            <a class="clickeable" @click="sendMorningNotification(camp)">Enviar notificacion matutina</a>
                          </li>
                          <li>
                            <a class="clickeable" @click="sendAfternoonNotification(camp)">Enviar notificacion vespertina</a>
                          </li>
                        </ul>
                </td>
                <td v-else></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="modal" ref="modalEnviarNotificacion" role="dialog">
      <div class="modal-dialog" v-if="selectedUser" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Enviar notificacion personalizada</h4>
          </div>
            <div class="modal-body">
              <div class="smart-form">
                <div class="form-group">
                  <label for="">Se enviará a:</label>
                  <span class="form-control">{{selectedUser.displayName}} - +549{{selectedUser.telefonoCelular}}</span>
                </div>

                <div class="form-group">
                  <label for="">Texto</label>
                  <textarea rows="5"  class="form-control" v-model="notificationText"></textarea>
                </div>
                <div class="form-group">
                  <div class="text-center center-block">
                    <button @click="doSendNotification()" class="btn btn-fill">Enviar</button>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>

    <div class="modal" ref="modalCambiarToken" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Cambiar Token de Wablas</h4>
          </div>
            <div class="modal-body">
              <div class="smart-form">
                <div class="form-group">
                  <label for="">Token</label>
                  <input class="form-control" type="text" v-model="wablasToken">
                </div>
                <div class="form-group">
                  <div class="text-center center-block">
                    <button @click="changeWablasToken()" class="btn btn-fill">Cambiar</button>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>


  </section>
</template>
<script>
import moment from 'moment'
import $ from 'jquery'
import '../../assets/css/select2_status.css'
import '../../assets/css/select2.css'
import {sortBy} from 'lodash'
import 'select2'
import swal from 'sweetalert2'

const PhoneNumber = require('awesome-phonenumber')

moment.locale('es')

export default {
  computed: {},
  data () {
    return {
      errorCellphoneFormat: false,
      errorCellphoneUnique: false,
      wablasToken: '',
      empresas: [],
      filtros: {notify: 'all'},
      sucursales: [],
      usuarios: [],
      page: 0,
      offset: 0,
      loading: false,
      editingUser: undefined,
      originalUser: undefined,
      selectedUser: undefined,
      notificationText: ''
    }
  },
  methods: {
    filtroNotificable (value) {
      const me = this
      me.filtros.notify = value
    },
    edit (camp) {
      const me = this
      camp.editing = true
      me.editingUser = { _id: camp._id }
      me.editingUser.telefonoCelular = camp.telefonoCelular
      me.originalUser = camp
      this.$forceUpdate()
    },
    showModalChangeToken () {
      const me = this
      $(me.$refs.modalCambiarToken).modal()
    },
    changeWablasToken () {
      const me = this
      swal({
        title: 'Confirme operación',
        text: '¿Desea cambiar el token de Wablas?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No, dejar sin efecto'
      }).then(() => {
        me.$http.post('/api/admin/notifications/token', {token: me.wablasToken}).then(({body}) => {
          $(me.$refs.modalCambiarToken).modal('hide')
          me.$emit('mostrar-notificacion', 'Se cambio el token de Wablas', 'success')
        }, (err) => {
          console.log(err)
        })
      }, (dismiss) => {
        $(me.$refs.modalCambiarToken).modal('hide')
      })
    },
    sendNotification (user) {
      const me = this
      me.selectedUser = user
      me.notificationText = ''
      this.$forceUpdate()
      $(me.$refs.modalEnviarNotificacion).modal()
    },
    sendAfternoonNotification (user) {
      const me = this
      me.$http.post('/api/admin/notifications/afternoon', {userId: user._id}).then(({body}) => {
        console.log(body)
        alert(body.text)
        me.$emit('mostrar-notificacion', 'Se envio el mensaje correctamente', 'success')
      }, (err) => {
        console.log(err)
        this.$emit('mostrar-notificacion', 'No se pudo enviar el mensaje', 'error')
      })
    },
    sendMorningNotification (user) {
      const me = this
      me.$http.post('/api/admin/notifications/morning', {userId: user._id}).then(({body}) => {
        console.log(body)
        alert(body.text)
        me.$emit('mostrar-notificacion', 'Se envio el mensaje correctamente', 'success')
      }, (err) => {
        console.log(err)
        this.$emit('mostrar-notificacion', 'No se pudo enviar el mensaje', 'error')
      })
    },
    doSendNotification () {
      const me = this
      me.$http.post('/api/admin/notifications/send', {phone: me.selectedUser.telefonoCelular, text: me.notificationText}).then(({body}) => {
        me.$emit('mostrar-notificacion', 'Se envio el mensaje correctamente', 'success')
      }, (err) => {
        console.log(err)
        this.$emit('mostrar-notificacion', 'No se pudo enviar el mensaje', 'error')
      })
      me.selectedUser = undefined
      me.notificationText = ''
      $(me.$refs.modalEnviarNotificacion).modal('hide')
    },
    cancel () {
      const me = this
      me.editingUser = undefined
      me.originalUser.editing = false
      me.originalUser = undefined
      this.$forceUpdate()
    },
    save () {
      const me = this
      let input = me.editingUser.telefonoCelular
      input = '+549' + input
      if (new PhoneNumber(input, 'AR').isValid() || !me.editingUser.telefonoCelular) {
        this.errorCellphoneUnique = false
        this.errorCellphoneFormat = false
        me.$http.post('/api/admin/notifications/saveUser', {_id: me.editingUser._id, telefonoCelular: me.editingUser.telefonoCelular}).then(({body}) => {
          me.originalUser.telefonoCelular = me.editingUser.telefonoCelular
          me.originalUser.notificarWhatsapp = body.notificarWhatsapp
          me.originalUser.editing = false
          me.editingUser = undefined
          this.$forceUpdate()
          me.$emit('mostrar-notificacion', 'El usuario fue guardado correctamente', 'success')
        }, (err) => {
          console.log(err)
          me.errorCellphoneUnique = true
          // this.$emit('mostrar-notificacion', 'error', err)
        })
      }
    },
    filtrarUsuarios () {
      const me = this
      me.loading = true
      me.$http.post('/api/admin/notifications/search', me.filtros).then(({body}) => {
        me.usuarios = body
        me.loading = false
      }, (err) => {
        me.loading = false
        this.$emit('mostrar-notificacion', 'error', err)
      })
    },
    toggleNotifyUser (usr) {
      const me = this
      let notify = usr.notificarWhatsapp
      if (notify) {
        notify = false
      } else {
        notify = true
      }
      me.$http.post('/api/admin/notifications/toggleNotifyUser', {_id: usr._id, notificarWhatsapp: notify}).then(({body}) => {
        usr.notificarWhatsapp = body.notificarWhatsapp
        me.$emit('mostrar-notificacion', 'El usuario fue guardado correctamente', 'success')
        this.$forceUpdate()
      }, (err) => {
        me.loading = false
        this.$emit('mostrar-notificacion', 'error', err)
      })
    },
    cargar () {
      const me = this
      me.loading = true
      me.$http.get('/api/admin/notifications/init').then(({body}) => {
        me.empresas = sortBy(body.sucursales, s => s.empresa.razonSocial)
        if (body.token) {
          me.wablasToken = body.token.token
        }
      }, e => console.error(e)).then(() => {
        me.loading = false
        $(me.$refs.slEmpresa).select2({
          placeholder: 'Seleccione una empresa'
        }).on('change', (e) => {
          me.filtros.empresas = $(me.$refs.slEmpresa).val()
          me.filtrar()
        })
      })
    }
  },
  mounted () {
    const me = this
    me.cargar()
  },
  watch: {}
}
</script>
<style scoped>
.modal {
  background-color: white;
}
.derecha {
  text-align: right;
}
.status-recibido {
  background-color: #f28893;
  color: #333;
}
.status-cocina {
  background-color: #ffc182;
  color: #333;
}
.status-empaquetado {
  background-color: #74a9b3;
  color: #333;
}
.status-entregado {
  background-color: #93a512;
  color: #333;
}
.status-cancelado {
  background-color: #666;
  color: #fff;
}
.btn-sm {
  height: 32px;
}
</style>



// WEBPACK FOOTER //
// List.vue?cccc2b0c